import React from "react";
import GoalsTable from "./GoalsTable";
import "./style.css";

const DevelopmentGoals = () => {
    return <GoalsTable />;
};

export default DevelopmentGoals;
